<div class="bg-dotted">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-sm-4">
        <div class="text-404 pt-2 pb-2 animate__animated animate__bounce">
          <h1 class="mt-4">Ups!</h1>
          <p class="text-main">No hemos podido encontrar la página que buscas.</p>
          <p class="mt-2">Código de error 404</p>
          <div class="mt-5">
            <a routerLink="/" class="btn btn-outline-success">PÁGINA DE INICIO</a>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <img src="assets/bot/cipbot_404.png" class="img-fluid animate__animated animate__bounceInDown">
      </div>
    </div>
  </div>
</div>